/**
 * ReceptionAutoRouter — keep Reception as the primary home screen on all devices.
 */
import React from "react";
import Reception from "../../pages/Reception";

export default function ReceptionAutoRouter() {
  return <Reception />;
}
